export default {
  loginTitle: 'Welcome Back',
  loginSubtitle: 'Sign in to your account',
  signupTitle: 'Create Account',
  signupSubtitle: 'Sign up for a new account',
  email: 'Email',
  password: 'Password',
  loginButton: 'Sign In',
  signupButton: 'Sign Up',
  processing: 'Processing...',
  switchToLogin: 'Already have an account? Sign in',
  switchToSignup: 'Don\'t have an account? Sign up',
  backToHome: 'Back to Home',
  loginSuccess: 'Login successful!',
  signupSuccess: 'Sign up complete! Please check your email.',
  errors: {
    invalidCredentials: 'Invalid email or password',
    emailNotConfirmed: 'Email verification required',
    userExists: 'Email already registered',
    general: 'An error occurred',
  },
};
